import React, { useState, useEffect, use } from 'react';

// material-ui
import {
    Box,
    Grid,
    Typography,
    Button,
    Dialog,
    FormControlLabel,
    Checkbox
} from "@mui/material";
import { TCInput } from 'components/TopCourtComponents/Input/TopCourtInput';
import { toast } from 'react-toastify';
import { createPackageSportCourtType, updatePackageSportCourtType, deletePackageSportCourtType } from 'services/packageSportCourtTypeService';
import { getSportCourtTypes } from 'services/placeServices';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import ButtonComponent from 'views/components/buttonComponent';
import BoxButtonComponent from 'views/components/boxButtonComponent';
import ConfirmDialogComponent from 'views/components/cofirmDialogComponent';
import { validation } from 'helper/Form';

export default function AddValuePackCategoryDialog({ isGlobal, merchantId, placeId, setDialog, data, handleClose }) {
    const [isSaving, setIsSaving] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const [confirmOpen, setConfirmOpen] = useState(false)

    const [sportCourtType, setSportCourtType] = useState([]);
    const [form, setForm] = useState({
        name: '',
        isAllCourt: false,
        sportCourtTypeId: [], // _id from sportCourtType
    });

    const [joi, setJOI] = useState({
        name: "required",
        isAllCourt: "required",
    })

    useEffect(() => {
        if (data) {
            console.log('here data', data)
            data.sportCourtTypeId = data.sportCourtTypeId.map(v => { return v._id })
            setForm(prev => ({
                ...prev,
                ...data
            }))
        }
    }, [data])

    useEffect(() => { console.log('here data form', form) }, [form])

    useEffect(() => {
        setJOI(prev => ({
            name: !validation.isNotEmpty(form.name) ? "Required" : "",
            isAllCourt: !validation.isNotEmpty(form.isAllCourt) ? "Required" : "",
        }))
    }, [form])

    useEffect(() => {
        loadSportCourtType()
    }, [setDialog.open]);

    const createOrUpdate = () => {
        setIsSaving(true);
        if (form._id) {
            update()
        } else {
            create()
        }
    }

    const create = async () => {
        let body = { ...form, merchantId: merchantId, placeId: placeId }
        try {
            let { data, error } = await createPackageSportCourtType(body);
            if (error) throw error;
            if (data) {
                toast.success('Value pack category created');
                handleClose();
                setIsSaving(false);
                clearForm();
            }
        } catch (error) {
            setIsSaving(false);
            console.log(error);
        }
    }

    const update = async () => {
        try {
            let { data, error } = await updatePackageSportCourtType(form);
            if (error) throw error;
            if (data) {
                toast.success('Value pack category updated successfully');
                clearForm();
                handleClose();
                setIsSaving(false);
            }
        } catch (error) {
            setIsSaving(false);
            console.log(error);
        }
    }

    const deleteData = async (id) => {
        try {
            setIsDeleting(true);
            const { data, error } = await deletePackageSportCourtType(id);
            if (error) throw error;

            toast.success('Value pack category deleted successfully');
            handleClose(); // misal menutup modal form atau refresh list
        } catch (err) {
            toast.error("Failed to delete");
            console.error(err);
        } finally {
            setIsDeleting(false);
        }
    };

    const handleDelete = () => {
        setConfirmOpen(true); // munculkan dialog konfirmasi
    };

    const handleConfirmDelete = async () => {
        await deleteData(form._id);
        setConfirmOpen(false); // tutup dialog
    };

    const loadSportCourtType = async () => {
        try {
            let { data, error } = await getSportCourtTypes({
                isActive: true,
                merchantId: !isGlobal ? merchantId : '',
                placeId: !isGlobal ? placeId : ''
            })
            if (error) { console.log(error); }
            console.log('here hceck data', data)
            if (data) { setSportCourtType(data) }
        } catch (error) { }
    }

    const onChange = (e) => {
        try {
            setForm(prev => ({
                ...prev,
                ...e
            }))
        } catch (error) { }
    }

    const clearForm = () => {
        setForm({
            name: '',
            isAllCourt: false,
            sportCourtTypeId: [], // _id from sportCourtType
        })
    }

    return (
        <>
            <Dialog open={setDialog.open} onClose={handleClose}>
                <Box sx={{ padding: 2, width: 'auto', maxWidth: 370 }}>
                    <Typography variant="h6" gutterBottom>
                        Add Value Pack Category
                    </Typography>
                    <Box component="form" noValidate autoComplete="off">
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                {/* <TCCreatableSelect label={'Value Pack Category Name'} options={[]} value={form.sportTypeSelected} onChange={(e) => {
                                    setForm({
                                        ...form,
                                        valuePackCategoryId: e.value,
                                        valuePackCategorySelected: e
                                    })
                                }} inDialog={true}/> */}
                                <TCInput
                                    label="Value Pack Category Name*"
                                    value={form.name}
                                    onChange={(e) => { onChange({ name: e.currentTarget.value }) }}
                                    showAlert={joi.name}
                                />
                            </Grid>
                            <Grid container xs={12} sx={{ p: 2, pt: 1 }}>
                                <Grid item md={12} xs={12}>
                                    <FormControlLabel control={<Checkbox id="all-court-checkbox" checked={form.isAllCourt ? true : false} onChange={() => {
                                        onChange({ isAllCourt: !form.isAllCourt, courtType: 'all_court', sportCourtTypeId: !form.isAllCourt ? sportCourtType.map(v => { return v._id }) : [] })
                                    }} />} label={<TCLabel>Select All</TCLabel>} />
                                </Grid>
                                <Grid item container md={12} xs={12}>
                                    {
                                        sportCourtType.map((value) => {
                                            return (
                                                <FormControlLabel control={<Checkbox id={`${value._id}-court-checkbox`} disabled={form.isAllCourt}
                                                    checked={form.isAllCourt ? true : form.sportCourtTypeId ? form.sportCourtTypeId.indexOf(value._id) >= 0 : false}
                                                    onChange={() => {
                                                        let sportCourtTypes = form.sportCourtTypeId || []
                                                        let currIndex = sportCourtTypes.indexOf(value._id)
                                                        if (currIndex >= 0) {
                                                            sportCourtTypes.splice(currIndex, 1)
                                                        } else {
                                                            // Logic BE set selected > 1 => 'all_court'
                                                            // sportCourtTypes = []
                                                            sportCourtTypes.push(value._id)
                                                        }
                                                        onChange({ sportCourtTypeId: sportCourtTypes, isAllCourt: (sportCourtTypes.length == sportCourtType.length) })
                                                    }} />} label={<TCLabel>{`${value.sportTypeId.name
                                                        } ${value.courtTypeId.name}${value.merchantId?.name ? ` - (${value.merchantId?.name})` : ''}`}</TCLabel>} />
                                            )
                                        })
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        <BoxButtonComponent justify={form?._id ? 'space-between' : 'flex-end'} direction="row">
                            {/* {form?._id && (
                                <ButtonComponent
                                    onClick={handleDelete}
                                    loading={isDeleting}
                                    label="Delete"
                                    loadingLabel="Deleting..."
                                    buttonColor="error"
                                    spinnerColor="error.main"
                                    textColor="#fff"
                                />
                            )} */}
                            <Box display="flex" gap={1}></Box>
                            <Box display="flex" gap={1}>
                                <Button variant="outlined" color="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <ButtonComponent
                                    disabled={!(form.name && (form.isAllCourt || form.sportCourtTypeId.length > 0))}
                                    onClick={() => createOrUpdate()}
                                    loading={isSaving}
                                    label="Save"
                                    loadingLabel="Saving..."
                                />
                            </Box>
                        </BoxButtonComponent>
                    </Box>
                </Box>
            </Dialog>
        </>
    )
}